module.exports = __webpack_public_path__ + "static/media/add_white.b5c1f1ee.svg";